import { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { scrollState } from "../lib/scrollStore";
import { sampleCameraPath } from "./cameraPath";

export default function CameraRig({ fractions }) {
  const currentLook = useRef(new THREE.Vector3(0, 6, 0));

  useFrame(({ camera }, delta) => {
    const { position, lookAt } = sampleCameraPath(scrollState.progress, fractions);
    const damp = 1 - Math.pow(0.001, delta);
    camera.position.lerp(position, Math.min(damp * 2.2, 1));
    currentLook.current.lerp(lookAt, Math.min(damp * 2.2, 1));
    camera.lookAt(currentLook.current);
  });

  return null;
}
